import { useQuery } from "@tanstack/react-query";
import {
  EventLogsPaymentPeriod,
  EventLogsSubscription,
  EventLogsSubscriptionsSchema,
} from "./models";
import {
  fetchSubscription,
  fetchSubscriptionPaymentsPeriods,
  fetchSubscriptions,
  fetchSubscriptionsSchema,
} from "./api";

interface PagedContent<T> {
  content: T[];
  totalElements: number;
}

export const useFetchSubscriptionsSchema = () =>
  useQuery<EventLogsSubscriptionsSchema, Error>({
    queryKey: ["event-logs-subscriptions-schema"],
    queryFn: ({ signal }) => fetchSubscriptionsSchema({ signal }),
  });

export const useFetchSubscriptions = (
  filters: string | undefined,
  page: number,
  size: number,
  sort: string[]
) =>
  useQuery<PagedContent<EventLogsSubscription>, Error>({
    queryKey: ["event-logs-subscriptions", { filters, page, size, sort }],
    queryFn: ({ signal }) =>
      fetchSubscriptions({ filters, page, size, sort }, { signal }),
    placeholderData: (prev) => prev,
  });

export const useFetchSubscription = (subscriptionId: string) =>
  useQuery<EventLogsSubscription, Error>({
    enabled: !!subscriptionId,
    queryKey: ["event-logs-subscription", { subscriptionId }],
    queryFn: ({ signal }) => fetchSubscription(subscriptionId, { signal }),
  });

export const useFetchSubscriptionPaymentsPeriods = (
  filters: string | undefined,
  page: number,
  size: number,
  sort: string[]
) =>
  useQuery<PagedContent<EventLogsPaymentPeriod>, Error>({
    queryKey: ["event-logs-subscriptions", { filters, page, size, sort }],
    queryFn: ({ signal }) =>
      fetchSubscriptionPaymentsPeriods(
        { filters, page, size, sort },
        { signal }
      ),
    placeholderData: (prev) => prev,
  });
